import React from "react";
import {css} from "@emotion/react";
import styled from "@emotion/styled";

import {Button} from "@pg-design/button-module";
import {calculateRemSize, mt, p} from "@pg-design/helpers-css-strings";
import {CloseIcon} from "@pg-design/icons-module";
import {Image} from "@pg-design/image-module";
import {getThemeBreakpoint, getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";

import {concatWithBrandName} from "../../../app/utils/concat_with_brand_name";
import {RPModal} from "../../../atoms/RPModal";
import {hitPlanSelectEvent} from "../../tracking/plan_select_gtm_events";

const plan_img = require("../../images/plan.png");
const plan_img_small = require("../../images/plan-small.png");
const plan_pdf_img = require("../../images/plan-pdf.png");
const plan_pdf_img_small = require("../../images/plan-pdf-small.png");

export enum PlanType {
    STANDARD = "standard",
    ORIGINAL = "original"
}

const planSelectBoxesContent = [
    {img: plan_img, imgSmall: plan_img_small, text: `${concatWithBrandName("Wystandaryzowany od")}`, planType: PlanType.STANDARD},
    {
        img: plan_pdf_img,
        imgSmall: plan_pdf_img_small,
        text: (
            <>
                Oryginalny <br />
                od dewelopera
            </>
        ),
        planType: PlanType.ORIGINAL
    }
];

interface IProps {
    isOpen: boolean;
    onClose: () => void;
}

export const PlanSelectModal = (props: IProps) => {
    const {isMobile} = useUserDevice();

    const onSelect = (planType: PlanType) => {
        hitPlanSelectEvent({event_category: planType, event_action: "select"});
        props.onClose();
    };

    const onClose = () => {
        hitPlanSelectEvent({event_action: "close"});
        props.onClose();
    };

    return (
        <SelectPlanModal
            isOpen={props.isOpen}
            onModalClose={onClose}
            closeButton={(closeModal) => <CloseIcon onClick={closeModal} size="2.4" wrapperSize="2.4" wrapperColor="transparent" css={closeStyle} />}
            overlayStyle={{
                background: getThemeVariable("colors.secondary")
            }}
        >
            <div>
                <Text as="p" variant="headline_4" mb="3.2rem" align="center" css={textStyle}>
                    Wybierz rodzaj rzutu mieszkania
                </Text>
                <div css={boxesWrapper}>
                    {planSelectBoxesContent.map((el) => {
                        return (
                            <div key={el.planType} css={planSelectBox}>
                                <Image width={isMobile ? "148px" : "247px"} height={isMobile ? "83px" : "187px"} alt="" src={isMobile ? el.imgSmall : el.img} />
                                <Text variant="body_copy_2" align="center" strong>
                                    {el.text}
                                </Text>
                                <Button variant="filled_primary" size="small" css={btnStyle} onClick={() => onSelect(el.planType)}>
                                    Wybierz
                                </Button>
                            </div>
                        );
                    })}
                </div>
            </div>
        </SelectPlanModal>
    );
};

const SelectPlanModal = styled(RPModal)`
    ${p(3, 1.5)};
    background-color: ${getThemeVariable("colors.gray.100")};
    height: 100%;
    width: 100%;
    border-radius: unset;

    @media (min-width: ${getThemeBreakpoint().md}) {
        ${p(3)};
        height: unset;
        width: unset;
        border-radius: ${calculateRemSize(2)};
    }
`;

const boxesWrapper = css`
    display: flex;
    flex-direction: row;
    gap: ${calculateRemSize(1)};

    @media (min-width: ${getThemeBreakpoint().md}) {
        max-width: 662px;
        gap: ${calculateRemSize(3)};
    }
`;

const planSelectBox = css`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    ${p(1)};
    background-color: #fff;
    max-height: 220px;
    border-radius: ${calculateRemSize(2)};
    width: 50%;

    @media (min-width: ${getThemeBreakpoint().md}) {
        max-height: 355px;
        ${p(3)};
    }
`;

const btnStyle = css`
    width: 100%;
    ${mt(1)};

    @media (min-width: ${getThemeBreakpoint().md}) {
        ${mt(3)};
    }
`;

const closeStyle = css`
    position: absolute;
    top: -${calculateRemSize(1.5)};
    right: 0;
    cursor: pointer;

    @media (min-width: ${getThemeBreakpoint().md}) {
        top: 0;
        right: 0;
    }
`;

const textStyle = css`
    max-width: 80%;

    @media (min-width: ${getThemeBreakpoint().md}) {
        max-width: unset;
    }
`;
import React from "react";
import {css} from "@emotion/react";
import styled from "@emotion/styled";

import {Button} from "@pg-design/button-module";
import {calculateRemSize, mt, p} from "@pg-design/helpers-css-strings";
import {CloseIcon} from "@pg-design/icons-module";
import {Image} from "@pg-design/image-module";
import {getThemeBreakpoint, getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";

import {concatWithBrandName} from "../../../app/utils/concat_with_brand_name";
import {RPModal} from "../../../atoms/RPModal";
import {hitPlanSelectEvent} from "../../tracking/plan_select_gtm_events";

const plan_img = require("../../images/plan.png");
const plan_img_small = require("../../images/plan-small.png");
const plan_pdf_img = require("../../images/plan-pdf.png");
const plan_pdf_img_small = require("../../images/plan-pdf-small.png");

export enum PlanType {
    STANDARD = "standard",
    ORIGINAL = "original"
}

const planSelectBoxesContent = [
    {img: plan_img, imgSmall: plan_img_small, text: `${concatWithBrandName("Wystandaryzowany od")}`, planType: PlanType.STANDARD},
    {
        img: plan_pdf_img,
        imgSmall: plan_pdf_img_small,
        text: (
            <>
                Oryginalny <br />
                od dewelopera
            </>
        ),
        planType: PlanType.ORIGINAL
    }
];

interface IProps {
    isOpen: boolean;
    onClose: () => void;
}

export const PlanSelectModal = (props: IProps) => {
    const {isMobile} = useUserDevice();

    const onSelect = (planType: PlanType) => {
        hitPlanSelectEvent({event_category: planType, event_action: "select"});
        props.onClose();
    };

    const onClose = () => {
        hitPlanSelectEvent({event_action: "close"});
        props.onClose();
    };

    return (
        <SelectPlanModal
            isOpen={props.isOpen}
            onModalClose={onClose}
            closeButton={(closeModal) => <CloseIcon onClick={closeModal} size="2.4" wrapperSize="2.4" wrapperColor="transparent" css={closeStyle} />}
            overlayStyle={{
                background: getThemeVariable("colors.secondary")
            }}
        >
            <div>
                <Text as="p" variant="headline_4" mb="3.2rem" align="center" css={textStyle}>
                    Wybierz rodzaj rzutu mieszkania
                </Text>
                <div css={boxesWrapper}>
                    {planSelectBoxesContent.map((el) => {
                        return (
                            <div key={el.planType} css={planSelectBox}>
                                <Image width={isMobile ? "148px" : "247px"} height={isMobile ? "83px" : "187px"} alt="" src={isMobile ? el.imgSmall : el.img} />
                                <Text variant="body_copy_2" align="center" strong>
                                    {el.text}
                                </Text>
                                <Button variant="filled_primary" size="small" css={btnStyle} onClick={() => onSelect(el.planType)}>
                                    Wybierz
                                </Button>
                            </div>
                        );
                    })}
                </div>
            </div>
        </SelectPlanModal>
    );
};

const SelectPlanModal = styled(RPModal)`
    ${p(3, 1.5)};
    background-color: ${getThemeVariable("colors.gray.100")};
    height: 100%;
    width: 100%;
    border-radius: unset;

    @media (min-width: ${getThemeBreakpoint().md}) {
        ${p(3)};
        height: unset;
        width: unset;
        border-radius: ${calculateRemSize(2)};
    }
`;

const boxesWrapper = css`
    display: flex;
    flex-direction: row;
    gap: ${calculateRemSize(1)};

    @media (min-width: ${getThemeBreakpoint().md}) {
        max-width: 662px;
        gap: ${calculateRemSize(3)};
    }
`;

const planSelectBox = css`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    ${p(1)};
    background-color: #fff;
    max-height: 220px;
    border-radius: ${calculateRemSize(2)};
    width: 50%;

    @media (min-width: ${getThemeBreakpoint().md}) {
        max-height: 355px;
        ${p(3)};
    }
`;

const btnStyle = css`
    width: 100%;
    ${mt(1)};

    @media (min-width: ${getThemeBreakpoint().md}) {
        ${mt(3)};
    }
`;

const closeStyle = css`
    position: absolute;
    top: -${calculateRemSize(1.5)};
    right: 0;
    cursor: pointer;

    @media (min-width: ${getThemeBreakpoint().md}) {
        top: 0;
        right: 0;
    }
`;

const textStyle = css`
    max-width: 80%;

    @media (min-width: ${getThemeBreakpoint().md}) {
        max-width: unset;
    }
`;
